import { render, staticRenderFns } from "./GestionTurnosSemana.vue?vue&type=template&id=4fbc6c43&scoped=true"
import script from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemana.vue?vue&type=style&index=0&id=4fbc6c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc6c43",
  null
  
)

export default component.exports